<template>
  <div v-show="displayFrontend" :class="{questions__save: safeFreeze}" class="questions">
    <h1 class="questions__header">{{ $t("Hardware delivery") }}</h1>
    <p class="questions--fullwidth">{{ $t("We would like to reminder you that the Rex-O-Matic requires a power outlet and ethernet cable to operate. Please make sure these cables are available.") }}</p>

    <div v-show="hardwareAmount>1">
      <b-form-checkbox
        v-model="delivery.deliveryMultipleAddress"
        class="checkbox"
        name="check-button"
        switch
        @change="disableInput($event)">
        {{ $t("Send Rex-O-Matic's to different addresses") }}
      </b-form-checkbox>
    </div>

    <div id="remarks_top">
    </div>

    <div id="billingAddress">
      <div class="hide">
        <h2 class="questions__subheader">
          {{ $t("Company name") }}
        </h2>
        <input
          id="deliveryCompanyName"
          v-model="delivery.deliveryCompanyName"
          class="form-control"
          type="text"/>
      </div>

      <div class="hide questions__halfInputWidth questions__halfInputWidthLeft">
        <h2 class="questions__subheader">
          {{ $t("To the attention of") }}
        </h2>
        <input
          id="deliveryContactName"
          v-model="delivery.deliveryContactName"
          class="questions__halfInputWidthInput form-control"
          type="text"/>
      </div>

      <div class="hide questions__halfInputWidth">
        <h2 class="questions__subheader">
          {{ $t("Email") }}
        </h2>
        <input
          id="deliveryContactEmail"
          v-model="delivery.deliveryContactEmail"
          class="questions__halfInputWidthInput form-control"
          type="text"/>
      </div>

      <div v-show="!delivery.deliveryMultipleAddress">
        <h2 class="questions__subheader">
          {{ $t("Search the delivery address") }}
        </h2>
        <input
          id="autocomplete"
          class="form-control"
          placeholder=""
          type="text"
          @focus="searchAddress"/>

        <h2 class="questions__subheader">
          {{ $t("Street and house number") }}
        </h2>
        <div class="inputinline">
          <input
            id="route"
            v-model="delivery.deliveryStreet"
            class="form-control"
            :disabled="addressInputDisabled"
            type="text"/>
        </div>

        <div class="deliveryCity">
          <h2 class="questions__subheader">
            {{ $t("City") }}
          </h2>
          <input
            id="locality"
            v-model="delivery.deliveryCity"
            class="form-control"
            :disabled="addressInputDisabled"
            type="text"/>
        </div>

        <div class="deliveryPostalCode">
          <h2 class="questions__subheader">
            {{ $t("Zip code") }}
          </h2>
          <input
            id="postal_code"
            v-model="delivery.deliveryPostalCode"
            class="form-control"
            :disabled="addressInputDisabled"
            type="text"/>
        </div>

        <input
          id="country"
          v-model="delivery.deliveryCountry"
          type="hidden"/>
      </div>
    </div>

    <div id="remarks_bottom">
      <h2 v-if="delivery.deliveryMultipleAddress" class="questions__subheader">
        {{ $t("Note the addresses and quantity") }}
      </h2>
      <h2 v-else class="questions__subheader">
        {{ $t("Remarks") }}
      </h2>

      <b-form-textarea
        id="deliveryNotes"
        v-model="delivery.deliveryNotes"
        class="questions__textarea"
        rows="3"/>
    </div>

    <input :value="$t('Save')" type="button" @click="handleSave"/>
    <p v-show="showSaveStatus" class="questions--savesuccess">{{ $t("Saved successfully!") }}</p>
  </div>
</template>

<script>
import SystemRequestService from "@/SystemRequestService";
import GlobalFunctions from "@/GlobalFunctions";

export default {
  name: 'RexOMatic',
  data() {
    return {
      displayFrontend: false,
      safeFreeze: false,
      showSaveStatus: false,
      hardwareAmount: 0,
      addressInputDisabled: true,
      delivery: {
        deliveryMultipleAddress: false,
        deliveryContactName: '',
        deliveryContactEmail: '',
        deliveryCompanyName: '',
        deliveryStreet: '',
        deliveryCity: '',
        deliveryPostalCode: '',
        deliveryCountry: '',
        deliveryNotes: '',
      },
    };
  },
  async beforeMount() {
    if (document.getElementById('mapsApi') === null) {
      const head = document.getElementsByTagName('head')[0];
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCuJky5bTKvL7nGSTb4QUtAMfqJRZVEgxQ&'
        + 'libraries=places';
      script.id = 'mapsApi';
      head.appendChild(script);
    }

    const result = await SystemRequestService.getProject(this.$route.params.hashedId);
    if (!result) {
      alert(this.$t("Error while obtaining your details. Please try again later or contact your Dyflexis consultant."));
      return;
    }

    this.hardwareAmount = result.hardwareAmount;
    if (this.hardwareAmount > 0) {
      this.delivery.deliveryMultipleAddress = result.deliveryMultiAddress;
      this.delivery.deliveryContactName = result.deliveryContactName;
      this.delivery.deliveryContactEmail = result.deliveryContactEmail;
      this.delivery.deliveryCompanyName = result.deliveryCompanyName;
      this.delivery.deliveryStreet = result.deliveryStreet;
      this.delivery.deliveryCity = result.deliveryCity;
      this.delivery.deliveryPostalCode = result.deliveryPostalCode;
      this.delivery.deliveryCountry = result.deliveryCountry;
      this.delivery.deliveryNotes = result.deliveryNotes;

      GlobalFunctions.setReadOnly(result.isSigned);
      localStorage.setItem('startingObject', JSON.stringify(this.delivery));
      this.displayFrontend = true;
    }
  },
  beforeRouteLeave: function (to, from, next) {
    if (!GlobalFunctions.acceptPageLeave(this.delivery, this.$t("You have made changes without saving them. Press cancel to ignore these changes and leave the page."))) {
      this.handleSave(false);
    }
    next();
  },
  methods: {
    disableInput($event) {
      this.delivery.deliveryMultipleAddress = $event;

      this.delivery.deliveryStreet = null;
      this.delivery.deliveryCity = null;
      this.delivery.deliveryPostalCode = null;
      this.delivery.deliveryCountry = null;
    },
    async handleSave(saveInitialObject) {
      this.safeFreeze = true;

      const result = await SystemRequestService.updateProject(this.delivery, this.$route.params.hashedId);
      if (!result || result.status !== 'success') {
        alert(this.$t("Error while updating, please send a screenshot of the fields on this page to your Dyflexis consultant!"));
        return;
      }

      if (saveInitialObject !== false) {
        localStorage.setItem('startingObject', JSON.stringify(this.delivery));
      }

      this.safeFreeze = false;
      this.showSaveStatus = true;
      setTimeout(() => {
        this.showSaveStatus = false;
      }, 3000);
    },
    searchAddress() {
      const autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), {types: []});
      autocomplete.setFields(['address_component']);
      autocomplete.addListener('place_changed', () => {
        this.addressInputDisabled = false;
        this.delivery.deliveryStreet = null;
        this.delivery.deliveryCity = null;
        this.delivery.deliveryPostalCode = null;

        let route = '';
        let streetnumber = '';
        let subpremise = '';
        const place = autocomplete.getPlace().address_components;
        for (let i = 0; i < place.length; i++) {
          const addressType = place[i].types[0];
          const val = place[i].long_name;

          if (addressType === "route") {
            route = val;
          }

          if (addressType === "street_number") {
            streetnumber = val;
          }

          if (addressType === "subpremise") {
            subpremise = val;
          }

          if (addressType === "locality") {
            this.delivery.deliveryCity = val;
          }

          if (addressType === "postal_code") {
            this.delivery.deliveryPostalCode = val;
          }

          if (addressType === "country") {
            this.delivery.deliveryCountry = val;
          }
        }
        this.delivery.deliveryStreet = route + ' ' + streetnumber + ' ' + subpremise;
      });
    },
  },
};
</script>
